



document.addEventListener('DOMContentLoaded', () => {
  const wrappers   = document.querySelectorAll('.media-wrapper');
  const allVideos  = document.querySelectorAll('.media-wrapper video');
  const iconTimers = new WeakMap();
  const ICON_HIDE_DELAY = 2000; // ms – how long the 🔊 icon stays visible

  // Hide the icon after a short delay (used for the unmute icon)
  function hideIconLater(wrapper) {
    const prev = iconTimers.get(wrapper);
    if (prev) clearTimeout(prev);

    const timer = setTimeout(() => {
      wrapper.classList.add('icon-hidden'); // CSS fades the icon out
    }, ICON_HIDE_DELAY);

    iconTimers.set(wrapper, timer);
  }

  // Ensure only ONE video is unmuted at a time
  function muteAllExcept(activeVideo) {
    allVideos.forEach(video => {
      if (video === activeVideo) return;

      video.muted = true;
      const w = video.closest('.media-wrapper');
      if (!w) return;

      w.classList.remove('is-unmuted');
      w.classList.remove('icon-hidden'); // show 🔇 again when that video plays
    });
  }

  wrappers.forEach(wrapper => {
    const video = wrapper.querySelector('video');
    if (!video) return;

    
    video.muted = true;              // required for autoplay on most devices
    video.play().catch(() => {
      // Mobile/iOS may block autoplay until user taps – that's fine.
    });

    // Mark as loading to show spinner until first frame is ready
    wrapper.classList.add('loading');

    const clearLoading = () => wrapper.classList.remove('loading');
    video.addEventListener('loadeddata', clearLoading);
    video.addEventListener('canplay',    clearLoading);

    // Track when video is actually playing (for showing the mute icon)
    video.addEventListener('playing', () => {
      wrapper.classList.add('playing');
    });
    ['pause', 'ended'].forEach(evt => {
      video.addEventListener(evt, () => {
        wrapper.classList.remove('playing');
      });
    });

    
    wrapper.addEventListener('click', () => {
      const willBeMuted = !video.muted;  // what state we’re going TO

      if (willBeMuted) {
        // Back to muted 🔇
        video.muted = true;
        wrapper.classList.remove('is-unmuted');  // icon becomes 🔇 again
        wrapper.classList.remove('icon-hidden'); // ensure icon can show if playing
      } else {
        // Unmute THIS video, mute all others
        muteAllExcept(video);
        video.muted = false;

        // On some devices a user gesture is required to start audio playback
        video.play().catch(() => {});

        wrapper.classList.remove('icon-hidden'); // show 🔊 immediately
        wrapper.classList.add('is-unmuted');
        hideIconLater(wrapper);                 // then fade icon away
      }
    });
  });
});